var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.93945 8L2.96973 11.9697L4.03039 13.0304L8.00011 9.06066L11.9698 13.0304L13.0305 11.9697L9.06077 8L13.0304 4.03039L11.9697 2.96973L8.00011 6.93934L4.0305 2.96973L2.96984 4.03039L6.93945 8Z","fill":"currentColor"}));
}

Close.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Close;

Close.default = Close;
